const ASSET_FNS = ['assetByAlias', 'assetByVersion', 'assetsByAlias', 'assetsByVersion'];

// An asset response must carry Asset Delivery API data. Anything else (an HTML error page from a
// misrouted proxy path, an empty body) would leave the app without config and in maintenance mode.
const isAssetResponse = response => {
  const data = response?.data?.data;
  return data != null && typeof data === 'object';
};

/**
 * Make the SDK's asset functions retry on `fallbackSdk` (Sharetribe's own CDN) whenever the
 * primary asset host fails or returns something that is not an asset response.
 * Mutates and returns `sdk`.
 */
export const withAssetFallback = (sdk, fallbackSdk, onFallback = () => {}) => {
  ASSET_FNS.forEach(fnName => {
    const primary = sdk[fnName];
    const fallback = fallbackSdk[fnName];
    if (typeof primary !== 'function' || typeof fallback !== 'function') {
      return;
    }
    sdk[fnName] = params =>
      Promise.resolve()
        .then(() => primary(params))
        .then(response => {
          if (!isAssetResponse(response)) {
            throw new Error('Unexpected asset response');
          }
          return response;
        })
        .catch(e => {
          onFallback(fnName, e);
          return fallback(params);
        });
  });
  return sdk;
};
